import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { FEATURED_CLUBS_CLUB_FRAGMENT } from '@base/api/fragments/featuredClubsClub'

export const FEATURED_CLUBS = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${FEATURED_CLUBS_CLUB_FRAGMENT}

  query featuredClubs(
    $filter: ListClubsFilter!
    $sortField: ClubSortField!
    $sortOrder: SortOrder!
    $offset: Int
    $limit: Int
    $randomize: Boolean
  ) {
    listClubs(
      filter: $filter
      sort: [{ sortField: $sortField, sortOrder: $sortOrder }]
      offset: $offset
      limit: $limit
      randomize: $randomize
    ) {
      ... on ListClubsOutput {
        clubs {
          ...FeaturedClubsClub
        }
        count
      }
      ... on ListClubsErrorOutput {
        errors {
          clubName
          sort
          limit
          offset
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
